import api from './api';

export const listEducatorAssignments = async (params = {}) => {
  const { data } = await api.get('/educator-assignments', { params });
  return data;
};

export const getEducatorAssignment = async (id) => {
  const { data } = await api.get(`/educator-assignments/${id}`);
  return data;
};

export const createEducatorAssignment = async (payload) => {
  const { data } = await api.post('/educator-assignments', payload);
  return data;
};

export const updateEducatorAssignment = async (id, payload) => {
  const { data } = await api.put(`/educator-assignments/${id}`, payload);
  return data;
};

export const deleteEducatorAssignment = async (id) => {
  const { data } = await api.delete(`/educator-assignments/${id}`);
  return data;
};

export default {
  listEducatorAssignments,
  getEducatorAssignment,
  createEducatorAssignment,
  updateEducatorAssignment,
  deleteEducatorAssignment,
};
